import { Drawer } from "@mui/material";
import { useDispatch } from "react-redux";
import { addmanagerpin, addmanageruidx } from "../../../../redux/Actions/SessionActions";
import { memo, useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../../../../../../App";
import "./index.css";
import { useSelector } from "react-redux";
import { getmangerPin, getmangeruidx } from "../../../../redux/Reducers/sessionReducer";
import { getManagers, validateManagerPin } from "../../../../../../../../config/Services";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";
import { eventTracker } from "../../../../../../../common/event-tracker/eventTracker";
import { eventTrackerConstant } from "../../../../../../../common/event-tracker/event-tracker-constants";

const ManagerAuthModal = (props) => {
  const dispatch = useDispatch();
  const [isAuth, setIsAuth] = useState(false);
  const [loader, setLoader] = useState(false);
  const managerNumber = useSelector(getmangeruidx);
  const mangerPin = useSelector(getmangerPin);
  const showSnackbar = useSnackbar();
  const [pinValue, setPinValue] = useState("");
  const [managerDetails, setManagerDetails] = useState({
    uidx: "",
    name: "",
  });
  const licenseId = localStorage.getItem("licenseId");
  const machineId = localStorage.getItem("machineId");
  const [managerList, setManagerList] = useState([]);
  const locId = localStorage.getItem("locId");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);
  const dropdownRef = useRef(null);

  const isOffline = props.storeMode === "OFFLINE" || !props.machinenewId;

  // Close dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [dropdownOpen]);

  // Reset state every time drawer opens/closes
  useEffect(() => {
    if (!props.managerModal) {
      setIsAuth(false);
      setPinValue("");
      setManagerDetails({ uidx: "", name: "" });
      setSelectedManager(null);
      setDropdownOpen(false);
      dispatch(addmanageruidx(""));
      dispatch(addmanagerpin(""));
    }
  }, [props.managerModal]);

  // Fetch manager list when drawer opens
  useEffect(() => {
    if (props.managerModal) {
      const payload = { contextId: locId };
      getManagers(payload).then((res) => {
        const response = res?.data?.data?.map((e) => ({
          value: e?.mobile_number,
          label: e?.first_name,
          uidx: e?.uidx,
        }));
        setManagerList(response || []);
      });
    }
  }, [props.managerModal]);

  const handleClose = () => {
    setIsAuth(false);
    setPinValue("");
    setSelectedManager(null);
    setDropdownOpen(false);
    dispatch(addmanageruidx(""));
    dispatch(addmanagerpin(""));
    props.handleManagerModalClose();
  };

  const handlepaymentOnline = () => {
    setLoader(true);
    let managerpayload = {
      mobile: managerNumber,
      primaryPassword: mangerPin,
    };
    if (machineId) {
      validateManagerPin(managerpayload)
        .then((res) => {
          showSnackbar("Successfully switched to online payment mode", "success");
          const metaData = {
            paymentMethod: "ONLINE",
            terminalId: licenseId,
            approvedBy: managerDetails?.uidx,
            approvedByName: managerDetails?.name,
          };
          eventTracker({ metaData, eventType: eventTrackerConstant.PAYMENT_MODE_CHANGED });
          setLoader(false);
          localStorage.setItem("cartStoreMode", "ONLINE");
          // localStorage.setItem("storeMode", "ONLINE");
          props.setmanagerModal(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setLoader(false);
        })
        .finally(() => {
          dispatch(addmanageruidx(""));
          dispatch(addmanagerpin(""));
          setPinValue("");
          setIsAuth(false);
        });
    } else {
      showSnackbar("You are not connected to a payment machine.", "error");
      setLoader(false);
    }
  };

  const handleProceedOffline = () => {
    setLoader(true);
    let managerpayload = {
      mobile: managerNumber,
      primaryPassword: mangerPin,
    };
    validateManagerPin(managerpayload)
      .then((res) => {
        showSnackbar("Successfully switched to offline payment mode", "success");
        const metaData = {
          paymentMethod: "OFFLINE",
          terminalId: licenseId,
          approvedBy: managerDetails?.uidx,
          approvedByName: managerDetails?.name,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.PAYMENT_MODE_CHANGED });
        setLoader(false);
        localStorage.setItem("cartStoreMode", "OFFLINE");
        // localStorage.setItem("storeMode", "OFFLINE");
        props.setmanagerModal(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      })
      .finally(() => {
        dispatch(addmanageruidx(""));
        dispatch(addmanagerpin(""));
        setPinValue("");
        setIsAuth(false);
      });
  };

  // Keyboard shortcut: Enter to confirm
  useEffect(() => {
    if (props.managerModal) {
      const handleKeyDown = (event) => {
        if (event.key === "Enter") {
          if (!isAuth) {
            setIsAuth(true);
          } else {
            if (isOffline && mangerPin !== "") {
              handlepaymentOnline();
            } else if (!isOffline && mangerPin !== "") {
              handleProceedOffline();
            }
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [props.storeMode, isAuth, mangerPin, props.managerModal, isOffline]);

  const handleConfirmSwitch = () => {
    if (isOffline) {
      handlepaymentOnline();
    } else {
      handleProceedOffline();
    }
  };

  return (
    <Drawer
      anchor="right"
      open={props.managerModal}
      onClose={handleClose}
      PaperProps={{ className: "pm-drawer-paper" }}
    >
      <div className="pm-drawer-root">
        {/* ── Header ── */}
        <div className="pm-drawer-header">
          <p className="pm-drawer-header-title">Payment Mode</p>
          <button className="pm-drawer-close-btn" onClick={handleClose} aria-label="Close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>

        {/* ── Body ── */}
        <div className="pm-drawer-body">
          {/* Status card */}
          <div className="pm-status-card">
            <div className="pm-status-card-header">
              <p className="pm-status-card-title">Payment Mode</p>
              <span className={`pm-status-badge ${isOffline ? "offline" : "online"}`}>
                <span className="pm-status-badge-dot" />
                {isOffline ? "Offline" : "Online"}
              </span>
            </div>
            <p className="pm-status-card-desc">
              Keep the terminal in the right mode and switch only when needed.
            </p>

            {/* Switch option inner card */}
            <div className="pm-switch-option-card">
              <div className="pm-switch-option-info">
                <p className="pm-switch-option-label">Switch Option</p>
                <p className="pm-switch-option-title">
                  {isOffline ? "Switch to Online" : "Switch to Offline"}
                </p>
                <p className="pm-switch-option-desc">
                  {isOffline
                    ? "Enable online payment acceptance for this terminal."
                    : "Pause online processing and continue with offline collection."}
                </p>
              </div>
              <button
                className={`pm-switch-btn ${isOffline ? "to-online" : "to-offline"}`}
                onClick={() => setIsAuth(true)}
                disabled={isAuth}
              >
                {isOffline ? "Switch to Online" : "Switch to Offline"}
              </button>
            </div>
          </div>

          {/* Manager auth card — slides in after clicking switch */}
          {isAuth && (
            <div className="pm-auth-card">
              <div className="pm-auth-fields-row">
                {/* Manager custom dropdown */}
                <div className="pm-field-group">
                  <p className="pm-field-label">Manager Name</p>
                  <div className="pm-custom-select-wrapper" ref={dropdownRef}>
                    <button
                      type="button"
                      className={`pm-custom-select-trigger ${dropdownOpen ? "open" : ""}`}
                      onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                      <span
                        className={selectedManager ? "pm-select-value" : "pm-select-placeholder"}
                      >
                        {selectedManager ? selectedManager.label : "Select manager"}
                      </span>
                      <svg
                        className={`pm-select-chevron ${dropdownOpen ? "rotated" : ""}`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>
                    {dropdownOpen && (
                      <div className="pm-custom-select-dropdown">
                        <div
                          className="pm-custom-select-option placeholder-option"
                          onClick={() => setDropdownOpen(false)}
                        >
                          Select manager
                        </div>
                        {managerList?.map((m) => (
                          <div
                            key={m.value}
                            className={`pm-custom-select-option ${
                              selectedManager?.value === m.value ? "pm-selected" : ""
                            }`}
                            onClick={() => {
                              setSelectedManager(m);
                              dispatch(addmanageruidx(m.value));
                              setManagerDetails({ uidx: m?.uidx, name: m?.label });
                              setDropdownOpen(false);
                            }}
                          >
                            <span className="pm-option-name">{m.label}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* PIN input */}
                <div className="pm-field-group">
                  <p className="pm-field-label">Manager PIN</p>
                  <input
                    className="pm-pin-input"
                    type="password"
                    inputMode="numeric"
                    placeholder="Enter 4-digit PIN"
                    autoComplete="new-password"
                    maxLength={4}
                    value={pinValue}
                    onChange={(e) => {
                      const val = e.target.value;
                      setPinValue(val);
                      dispatch(addmanagerpin(val));
                    }}
                  />
                </div>
              </div>

              {/* Action buttons */}
              <div className="pm-auth-actions">
                <button className="pm-auth-btn cancel" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className={`pm-auth-btn confirm ${loader ? "loading" : ""}`}
                  disabled={mangerPin.length < 4 || !managerNumber || loader}
                  onClick={handleConfirmSwitch}
                >
                  {loader ? "Switching..." : "Confirm Switch"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default memo(ManagerAuthModal);
